import { css, Stack, useMediaQuery } from '@mui/material'
import { CalendarStatus } from '@prisma/client'
import { useTranslation } from 'next-i18next'
import { PropsWithChildren, useContext } from 'react'
import { Button, ButtonVariant } from 'components/common/Button'
import { themeUtils } from 'styles/theme'
import { ButtonsContainer } from './DateTabContent.style'
import { SearchBarContext } from './SearchBarContext'
import { SearchTab } from './SearchBarHeader'
import { TypeAutocomplete } from './TypeAutocomplete'
import { TypeTabContainer } from './TypeTabContent.style'

export type TypeTab = EventType | EventCategory

export type EventType = {
  eventName: string
  eventSlug: string
  eventIsFeatured: boolean
  objectID: string
  eventCountrySubdivisionDisplayCodeLevel2: string
  eventCity: string
  editionLiveStartDateTimestamp: number
  editionLiveEndDateTimestamp: number
  editionCalendarStatus: CalendarStatus | undefined
  _highlightResult: {
    eventName: { value: string }
  }
}

export type EventCategory = {
  key: string
  label: string
}

interface TypeTabContentProps extends PropsWithChildren {
  close: () => void
  setSearchTab: (tab: SearchTab) => void
}

export const TypeTabContent = ({
  children,
  close,
  setSearchTab
}: TypeTabContentProps) => {
  const { t } = useTranslation(['common', 'home'])
  const { setRaceType, setRaceSearch, submitSearch } =
    useContext(SearchBarContext)
  const isMobile = useMediaQuery(themeUtils.maxWidth.md)

  const handleSubmit = () => {
    submitSearch()
    close?.()
  }
  return (
    <TypeTabContainer>
      <Stack
        css={css`
          ${themeUtils.minWidth.md} {
            max-height: 450px;
            overflow-y: auto;
          }
          ${themeUtils.maxWidth.md} {
            max-height: calc(100vh - 270px);
            overflow: auto;
          }
        `}
      >
        {children}
        <TypeAutocomplete close={close} setSearchTab={setSearchTab} />
      </Stack>
      {isMobile && (
        <ButtonsContainer flexDirection="column" alignItems="initial" gap={2}>
          <Button
            label={t('header.cancel')}
            fullWidthOnMobile
            variant={ButtonVariant.Quaternary}
            onClick={close}
          />
          <Button
            label={t('header.search')}
            fullWidthOnMobile
            variant={ButtonVariant.Primary}
            onClick={handleSubmit}
          />
        </ButtonsContainer>
      )}
      {!isMobile && (
        <Button
          label={t('home:head.clear')}
          variant={ButtonVariant.Quaternary}
          onClick={() => {
            setRaceType(null)
            setRaceSearch('')
          }}
          css={css`
            justify-self: flex-end;
          `}
        />
      )}
    </TypeTabContainer>
  )
}
